import React from 'react';
import { Global, css } from '@emotion/core';
import { Tooltip, ITooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const tooltipBackground = '#1f1f1f';

export const getActivityActionTooltipId = (id: string): string =>
  `activity-action-tooltip-${id.replace(/[^a-zA-Z0-9_-]/g, '')}`;

const ActivityActionTooltip = (props: ITooltip): JSX.Element => {
  return (
    <>
      <Global
        styles={css`
          .activity-action-tooltip {
            background: ${tooltipBackground} !important;
            border-radius: 10px !important;
          }

          .activity-action-tooltip [class*='styles-module_content'] {
            background: transparent;
            border-radius: inherit;
            padding: 5px 9px;
          }

          .activity-action-tooltip [class*='styles-module_arrow'] {
            background: ${tooltipBackground} !important;
          }
        `}
      />
      <Tooltip
        place="top"
        offset={5}
        opacity={1}
        className="activity-action-tooltip"
        positionStrategy="fixed"
        style={{
          zIndex: 1000,
          color: '#fff',
          fontSize: 11,
          fontWeight: 500,
          lineHeight: 1,
        }}
        {...props}
      />
    </>
  );
};

export default ActivityActionTooltip;
